import React, { useState, useEffect, useMemo } from 'react'
import { Button, Modal, Table, message, Tag } from 'antd'
import { _convertObject } from "../helpers/convertObject"
import { getListBarcodeV41, getExportOrdersCSVv41 } from '../../services/api/apiBarcode'
import { Link } from 'react-router-dom'
import "./styles/index.scss"
import moment from 'moment'
import useExportJob from '../helpers/useExportJob'

const ModalDetailStaticsItem = (props) => {
    const { isOpen, onClose, filter, params } = props

    const [currentPage, setCurrentPage] = useState(1)
    const [data, setData] = useState([])
    const [limit, setLimit] = useState(20)
    const [loading, setLoading] = useState(false)
    const {exporting, startExport} = useExportJob('list-items:statics-detail')

    const isOvertime = useMemo(() => {
        if (!Object.keys(params).length) return false

        if (params.hasOwnProperty('products.remaining_time[from]')) return false

        return true

    }, [params])

    const handleTableChange = (page, pageSize) => {
        setCurrentPage(page)
        setLimit(pageSize)
    }

    useEffect(() => {
        _fetchData()
    }, [])

    const _fetchData = async () => {
        setLoading(true)
        try {
            const {photo_requested, ...restFilter} = filter
            const newFilters = {
                statistic_3d_items: true,
                ...restFilter
            }
            if(photo_requested) newFilters.request_photo_statuses = [photo_requested]
            
            const payload = _convertObject(newFilters)

            const resRead = await getListBarcodeV41(payload)

            const { success, barcodes = [], message: mess } = resRead.data

            if (!success) throw new Error(mess)

            const newData = barcodes.reduce((acc, item) => {
                const { filteredProducts = [], barcodeNumber } = Object.assign({}, item)
                const newFiltedProducts = filteredProducts.map(i => ({ ...i, barcodeNumber })) || []
                return acc.concat(newFiltedProducts)
            }, [])

            setData(newData)

        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const excludeNoteLabel = useMemo(() => {
        const parts = []
        if (filter.is_hold_ship === 'n') parts.push('Hold ship')
        if (filter.exclude_tags === 'waiting-update-design') parts.push('Request design')

        return parts.length ? `Ngoại trừ: ${parts.join(', ')}` : ''
    }, [filter.is_hold_ship, filter.exclude_tags])

    const renderTitleModal = () => {
        if (!Object.keys(params).length) return
        const { hasNote = '' } = Object.assign({}, params)
        const productsType = params["products.type"] || ''
        let title = ''

        if (params.hasOwnProperty('products.remaining_time[from]')) {
            if (!params["products.remaining_time[to]"]) {
                title = `Tổng số lượng item ${productsType} chưa quá hạn sản xuất`
            } else {
                title = `Thống kê số lượng item ${productsType} còn ${+params["products.remaining_time[from]"] + 1} ngày sản xuất`
            }
        }

        if (hasNote === 'y') {
            if (!!params["products.overtimeGt"]) {
                if (!!params["products.overtimeLte"]) {
                    title = `Thống kê số lượng item ${productsType} quá hạn sản xuất ${+params["products.overtimeGt"] + 1} ngày (do note)`
                } else {
                    title = `Thống kê số lượng item ${productsType} quá hạn sản xuất từ ${+params["products.overtimeGt"] + 1} ngày (do note)`
                }
            } else {
                title = `Tổng số lượng item ${productsType} quá hạn sản xuất (do note)`
            }
        }

        if (hasNote === 'n') {
            if (!!params["products.overtimeGt"]) {
                if (!!params["products.overtimeLte"]) {
                    title = `Thống kê số lượng item ${productsType} quá hạn sản xuất ${+params["products.overtimeLte"]} ngày`
                } else {
                    title = `Thống kê số lượng item ${productsType} quá hạn sản xuất từ ${+params["products.overtimeGt"] + 1} ngày`
                }
            } else {
                title = `Tổng số lượng item ${productsType} quá hạn sản xuất`
            }
        }

        return (
            <div className='d-flex justify-content-between align-items-center'>
                <div className='d-flex align-items-center'>
                    {title && <span className='font-weight-bold h4 mb-0 mr-2'>{title}</span>}
                    {excludeNoteLabel && <Tag color="blue">{excludeNoteLabel}</Tag>}
                </div>
                <Button type='primary' onClick={handleExport} loading={exporting} disabled={exporting}>
                    {exporting ? 'Exporting' : 'Export'}
                </Button>
            </div>
        )
    }

    const handleExport = async () => {
        try {
            let tagsExport = []
            if (filter.tags) tagsExport.push(...filter.tags)
            if (filter.list_tags) tagsExport.push(...filter.list_tags)

            const filterTags = {
                tags: tagsExport,
                statistic_3d_items: true
            }

            const { list_tags, tags, photo_requested, ...rest } = filter

            const cloneFilterExp = Object.assign({}, rest, filterTags)

            delete cloneFilterExp['created']
            delete cloneFilterExp['generated']
            delete cloneFilterExp['barcodeNumber']

            if (filter.created.hasOwnProperty('from')) {
                cloneFilterExp['created[from]'] = filter.created.from
            }

            if (filter.created.hasOwnProperty('to')) {
                cloneFilterExp['created[to]'] = filter.created.to
            }

            if (filter.generated.hasOwnProperty('from')) {
                cloneFilterExp['generated[from]'] = filter.generated.from
            }

            if (filter.generated.hasOwnProperty('to')) {
                cloneFilterExp['generated[to]'] = filter.generated.to
            }

            if (filter.barcodeNumber.hasOwnProperty('$gte')) {
                cloneFilterExp['barcodeNumber[$gte]'] = filter.barcodeNumber['$gte']
            }

            if (filter.barcodeNumber.hasOwnProperty('$lte')) {
                cloneFilterExp['barcodeNumber[$lte]'] = filter.barcodeNumber['$lte']
            }

            if (filter.hasOwnProperty('products.overtimeLte')) {
                cloneFilterExp['products.overtime[$lte]'] = parseFloat(filter['products.overtimeLte'])
                delete cloneFilterExp['products.overtimeLte']
            }

            if (filter.hasOwnProperty('products.overtimeGt')) {
                cloneFilterExp['products.overtime[$gt]'] = parseFloat(filter['products.overtimeGt'])
                delete cloneFilterExp['products.overtimeGt']
            }

            if (filter.hasOwnProperty('generate_label_config.delay_days')) {
                if (filter['generate_label_config.delay_days'].hasOwnProperty('from')) {
                    cloneFilterExp['generate_label_config.delay_days[from]'] = filter['generate_label_config.delay_days'].from
                    delete cloneFilterExp['generate_label_config.delay_days']
                }

                if (filter['generate_label_config.delay_days'].hasOwnProperty('to')) {
                    cloneFilterExp['generate_label_config.delay_days[to]'] = filter['generate_label_config.delay_days'].to
                    delete cloneFilterExp['generate_label_config.delay_days']
                }
            }

            if (filter.is_fba) {
                if (filter.is_fba === 'TikTok') {
                    cloneFilterExp.is_tiktok = 'y'
                    delete cloneFilterExp.is_fba
                } else if (filter.is_fba === 'n') {
                    cloneFilterExp.is_tiktok = 'n'
                }
            }

            if(photo_requested) cloneFilterExp.request_photo_statuses = [photo_requested]

            await startExport(
                () => getExportOrdersCSVv41({ ...cloneFilterExp }),
                { filename: `Orders-${moment().format('YYYY-MM-DD')}.csv` }
            )
        } catch (e) {
            message.error(e.message)
        }
    }

    const columns = [
        {
            title: <span style={{ fontWeight: 'bold' }}>Barcode item</span>,
            dataIndex: 'barcode_number',
            key: 'barcode_number',
            render: (_, r) => {
                const { barcodeNumber, pos } = Object.assign({}, r)
                if (!!barcodeNumber && !!pos) return <Link
                    className='cursor-pointer'
                    to={`/next-item-detail?item=${barcodeNumber}_${pos}`}
                    target="_blank"
                >{`#${barcodeNumber}_${pos}`}</Link>
            }
        },
        {
            title: <span style={{ fontWeight: 'bold' }}>Type</span>,
            dataIndex: 'type',
            key: 'type',
            width: 250
        },
        {
            title: <span style={{ fontWeight: 'bold' }}>Size</span>,
            dataIndex: 'size',
            key: 'size',
        },
        {
            title: <span style={{ fontWeight: 'bold' }}>Color</span>,
            dataIndex: 'color',
            key: 'color',
        },
        {
            title: <span style={{ fontWeight: 'bold' }}>Lô</span>,
            dataIndex: 'batch_name',
            key: 'batch_name',
        },
        {
            title: <span style={{ fontWeight: 'bold' }}>Status</span>,
            dataIndex: 'item_status',
            key: 'item_status',
        },
        {
            title: <span style={{ fontWeight: 'bold' }}>Production time/ Commitment time</span>,
            dataIndex: '_',
            key: '_',
            render: (_, r) => {
                const { production_time, commitment_time } = Object.assign({}, r)
                if (production_time && commitment_time) return <span className={`${isOvertime && 'text-danger'} font-weight-bold`}>{`${production_time} / ${commitment_time}`}</span>
            }
        },
    ]

    return (
        <Modal
            title={renderTitleModal()}
            visible={isOpen}
            onCancel={onClose}
            footer={null}
            width={1200}
            closable={false}
        >
            <Table
                columns={columns}
                dataSource={data}
                pagination={{
                    current: currentPage,
                    pageSize: limit,
                    onChange: handleTableChange,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    showSizeChanger: true,
                    total: data.length
                }}
                scroll={{
                    y: 550,
                }}
                loading={loading}
            />
        </Modal>
    )
}

export default ModalDetailStaticsItem